export default {"src":"/_next/static/media/icp.e3c3a643.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};